import logoDHL from "@assets/events-awards/sba/sbaDHL.png";
import logoBT from "@assets/logo-masthead.svg";
import { BlockTitle } from "@blocks/Blocks";
import Container from "@components/Container/Container";
import { useWindowSize } from "@hooks/useWindowSize";

/**
 * Component to render Organiser Details of SBA on homepage
 */
const OrganiserDetails = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <Container>
      <div className="justify-center justify-center px-3 pb-5 pt-12 text-left md:px-6 lg:px-0 lg:pl-7">
        <BlockTitle
          text="Jointly organised by"
          rootClassName="text-center mb-2 text-xl lg:text-8xl font-medium tracking-[1px]"
        />

        <div className="flex flex-col items-center justify-center md:flex-row">
          <div className="px-3">
            <img
              src={logoBT}
              width={isScreenLG ? 250 : 280}
              height={25}
              alt="The Business Times logo"
              className="my-6 md:pr-10 lg:pr-3"
            />
          </div>

          <div className="px-3">
            <img
              src={logoDHL}
              width={isScreenLG ? 191 : 212}
              height={44}
              alt="DHL logo"
              className="mx-16 my-6 ml-0 mt-0 pl-10 md:mt-6 lg:pl-3"
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default OrganiserDetails;
